module.exports = __webpack_public_path__ + "static/intel-logo-797a8cb489a9b06f035f344af99cccec.svg";